/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment } from "react"
import {
  Settings,
  GameRules,
  ProvablyFair,
  History,
  SetStake,
  AutoForm,
  BetReply,
} from "@orbitalgaming/games-frontend-library"
// TODO clean up intefaces
import { settings } from "./lib/CONTENTS"
import GameCustomRules from "./components/gameRules/GameCustomRules"
import CustomReply from "./components/betReply/CustomReply"

interface usePageProps {
  clickable: boolean
  colors: {
    primary: string
    primaryDark: string
    primaryLight: string
    secondary: string
    secondaryDark: string
    tertiary: string
    tertiaryDark: string
    quaternary: string
    secondaryBackground: string
    secondaryText: string
  }
  precision: number
  handleAbove: any
  audio: any
}
interface pageBasic {
  name: string
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
interface settings extends pageBasic {
  unBlur: boolean
  handleAudio?: any
  audio?: {
    sound: boolean
    music: boolean
    volume: string
  }
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface gm extends pageBasic {}

interface pf extends pageBasic {
  seeds?: any
  seedRequest?: any
  newSeedRequest?: any
}

interface auto extends pageBasic {
  stake: string
  setstake: any
  auto: boolean
  autoConfigs: any
  handleAutoConfigs: any
}
interface hist extends pageBasic {
  audio: {
    sound: boolean
    music: boolean
    volume: string
  }
  history: historyArray
  user_id: string
  handleNotification: any
  precision?: number
}
interface historyObject {
  type: string
  round_id: string
  user_name: string
  user_id: string
  betAmount: number
  bigWin: number
  currency: string
  gameplaydata: string
  history: number
  sessionNo: string
  time: string
  winAmount: number
  winCoef: number
}

interface historyArray {
  my: historyObject[]
  all: historyObject[]
  high: historyObject[]
}
interface ss extends pageBasic {
  SetStake: boolean
  currency: string
  stake: string
  handleStake: any
  isZero?: boolean
  sfx?: any
}
interface error extends pageBasic {
  errorPage: boolean
}
interface betReply extends pageBasic {
  precision?: number
  betInfo?: boolean
}
type pprs = settings | pf | gm | hist | ss | auto | error | betReply

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const usePage = (props: usePageProps): any => {
  const Page = (pageProps: pprs) => {
    const { name } = pageProps

    return (
      <Fragment>
        {name === "settings" && "unBlur" in pageProps && (
          <Settings {...pageProps} {...props} />
        )}
        {name === "Game Rules" && (
          <GameRules {...pageProps} {...props}>
            <GameCustomRules {...pageProps} {...props} />
          </GameRules>
        )}
        {name === "Provably Fair" && <ProvablyFair {...pageProps} {...props} />}
        {"audio" in pageProps && "unBlur" in pageProps && (
          <History {...pageProps} {...props} />
        )}
        {name === "Bet Reply" && (
          <BetReply {...pageProps} {...props}>
            <CustomReply {...pageProps} {...props} />
          </BetReply>
        )}
        {"SetStake" in pageProps && <SetStake {...pageProps} {...props} />}
        {"auto" in pageProps && <AutoForm {...pageProps} {...props} />}
      </Fragment>
    )
  }
  return [Page]
}
